import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

import { cn } from '../../styles/lib/utils';
import { Icon } from '../Icon';

type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>;

// TODO: fix spacing issues causing it to move
const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, ...props }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      data-slot="checkbox"
      className={cn(
        'peer border-input cursor-pointer dark:bg-input/30 dark:data-[state=checked]:bg-primary dark:data-[state=indeterminate]:bg-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=indeterminate]:border-primary aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow focus-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        forceMount
        data-slot="checkbox-indicator"
        className="grid h-full place-content-center text-current transition-none data-[state=unchecked]:hidden data-[state=indeterminate]:hidden"
      >
        <Icon icon="luCheck" size={16} />
      </CheckboxPrimitive.Indicator>
      <CheckboxPrimitive.Indicator
        forceMount
        data-slot="checkbox-indicator"
        className="grid h-full place-content-center text-current transition-none data-[state=checked]:hidden data-[state=unchecked]:hidden"
      >
        <Icon icon="luMinus" size={16} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ),
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
export type { CheckboxProps };
